import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import './floating-vue-extended-styles.css'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(FloatingVue, {
        themes: {
            tooltip: {
                placement: 'top',
                triggers: ['hover', 'focus'],
                delay: { show: 400, hide: 100 },
                distance: 8,
            },
        },
    })
})